// Generated by tools/logo3d/extract.mjs from tools/logo3d/Logo3D.fbx; do not
// edit by hand. The mark in three dimensions: a rounded square frame (the
// image) floating over a 12x12 halftone grid of discs (the mark hidden in it).
// Everything is in the model's own units, in the plane of the discs, with z
// along their shared normal.

export interface Logo3DModel {
	///@brief   The discs, as consecutive x, y, diameter triples.
	dots: number[]
	///@brief   Outer outline of the frame, as consecutive x, y pairs running
	///         counter-clockwise.
	frameOuter: number[]
	///@brief   Inner outline of the frame, same layout and direction.
	frameInner: number[]
	///@brief   Height of the frame's underside above the discs' plane.
	frameBottom: number
	///@brief   Height of the frame's top face above the discs' plane.
	frameTop: number
	///@brief   The scene's pose: the plate spun in its own plane, then leant
	///         back, in degrees.
	spin: number
	tilt: number
}

export const LOGO3D_MODEL: Logo3DModel = {
	dots: [
		-60, -60, 0.596, -49.091, -60, 1.351, -38.182, -60, 2.777, -27.273, -60, 3.763,
		-16.364, -60, 4.377, -5.455, -60, 4.671, 5.455, -60, 4.671, 16.364, -60, 4.377,
		27.273, -60, 3.763, 38.182, -60, 2.777, 49.091, -60, 1.351, 60, -60, 0.596,
		-60, -49.091, 1.351, -49.091, -49.091, 3.114, -38.182, -49.091, 4.377, -27.273, -49.091, 5.229,
		-16.364, -49.091, 5.747, -5.455, -49.091, 5.989, 5.455, -49.091, 5.989, 16.364, -49.091, 5.747,
		27.273, -49.091, 5.229, 38.182, -49.091, 4.377, 49.091, -49.091, 3.114, 60, -49.091, 1.351,
		-60, -38.182, 2.777, -49.091, -38.182, 4.377, -38.182, -38.182, 5.493, -27.273, -38.182, 6.22,
		-16.364, -38.182, 6.645, -5.455, -38.182, 6.837, 5.455, -38.182, 6.837, 16.364, -38.182, 6.645,
		27.273, -38.182, 6.22, 38.182, -38.182, 5.493, 49.091, -38.182, 4.377, 60, -38.182, 2.777,
		-60, -27.273, 3.763, -49.091, -27.273, 5.229, -38.182, -27.273, 6.22, -27.273, -27.273, 6.837,
		-16.364, -27.273, 7.175, -5.455, -27.273, 7.318, 5.455, -27.273, 7.318, 16.364, -27.273, 7.175,
		27.273, -27.273, 6.837, 38.182, -27.273, 6.22, 49.091, -27.273, 5.229, 60, -27.273, 3.763,
		-16.364, -16.364, 7.441, 16.364, -16.364, 7.441, -60, -16.364, 4.377, -27.273, -16.364, 7.175,
		27.273, -16.364, 7.175, 60, -16.364, 4.377, -49.091, -16.364, 5.747, -38.182, -16.364, 6.645,
		-5.455, -16.364, 7.538, 5.455, -16.364, 7.538, 38.182, -16.364, 6.645, 49.091, -16.364, 5.747,
		-60, -5.455, 4.671, -49.091, -5.455, 5.989, 49.091, -5.455, 5.989, -27.273, -5.455, 7.318,
		27.273, -5.455, 7.318, -38.182, -5.455, 6.837, -16.364, -5.455, 7.538, -5.455, -5.455, 7.601,
		5.455, -5.455, 7.601, 16.364, -5.455, 7.538, 38.182, -5.455, 6.837, 60, -5.455, 4.671,
		-38.182, 5.455, 6.837, -16.364, 5.455, 7.538, -5.455, 5.455, 7.601, 5.455, 5.455, 7.601,
		16.364, 5.455, 7.538, 38.182, 5.455, 6.837, -27.273, 5.455, 7.318, 27.273, 5.455, 7.318,
		-60, 5.455, 4.671, -49.091, 5.455, 5.989, 49.091, 5.455, 5.989, 60, 5.455, 4.671,
		-49.091, 16.364, 5.747, -38.182, 16.364, 6.645, -5.455, 16.364, 7.538, 5.455, 16.364, 7.538,
		38.182, 16.364, 6.645, 49.091, 16.364, 5.747, -60, 16.364, 4.377, -27.273, 16.364, 7.175,
		27.273, 16.364, 7.175, 60, 16.364, 4.377, -16.364, 16.364, 7.441, 16.364, 16.364, 7.441,
		-60, 27.273, 3.763, -49.091, 27.273, 5.229, -38.182, 27.273, 6.22, -27.273, 27.273, 6.837,
		-16.364, 27.273, 7.175, -5.455, 27.273, 7.318, 5.455, 27.273, 7.318, 16.364, 27.273, 7.175,
		27.273, 27.273, 6.837, 38.182, 27.273, 6.22, 49.091, 27.273, 5.229, 60, 27.273, 3.763,
		-60, 38.182, 2.777, -49.091, 38.182, 4.377, -38.182, 38.182, 5.493, -27.273, 38.182, 6.22,
		-16.364, 38.182, 6.645, -5.455, 38.182, 6.837, 5.455, 38.182, 6.837, 16.364, 38.182, 6.645,
		27.273, 38.182, 6.22, 38.182, 38.182, 5.493, 49.091, 38.182, 4.377, 60, 38.182, 2.777,
		-60, 49.091, 1.351, -49.091, 49.091, 3.114, -38.182, 49.091, 4.377, -27.273, 49.091, 5.229,
		-16.364, 49.091, 5.747, -5.455, 49.091, 5.989, 5.455, 49.091, 5.989, 16.364, 49.091, 5.747,
		27.273, 49.091, 5.229, 38.182, 49.091, 4.377, 49.091, 49.091, 3.114, 60, 49.091, 1.351,
		-60, 60, 0.596, -49.091, 60, 1.351, -38.182, 60, 2.777, -27.273, 60, 3.763,
		-16.364, 60, 4.377, -5.455, 60, 4.671, 5.455, 60, 4.671, 16.364, 60, 4.377,
		27.273, 60, 3.763, 38.182, 60, 2.777, 49.091, 60, 1.351, 60, 60, 0.596,
	],
	frameOuter: [
		-64.495, -47.775, -64.291, -50.159, -63.668, -52.753, -62.647, -55.218,
		-61.253, -57.492, -59.521, -59.521, -57.492, -61.253, -55.218, -62.647,
		-52.753, -63.668, -50.159, -64.291, -47.775, -64.495, 47.775, -64.495,
		50.159, -64.291, 52.753, -63.668, 55.218, -62.647, 57.492, -61.253,
		59.521, -59.521, 61.253, -57.492, 62.647, -55.218, 63.668, -52.753,
		64.291, -50.159, 64.495, -47.775, 64.495, 47.775, 64.291, 50.159,
		63.668, 52.753, 62.647, 55.218, 61.253, 57.492, 59.521, 59.521,
		57.492, 61.253, 55.218, 62.647, 52.753, 63.668, 50.159, 64.291,
		47.775, 64.495, -47.775, 64.495, -50.159, 64.291, -52.753, 63.668,
		-55.218, 62.647, -57.492, 61.253, -59.521, 59.521, -61.253, 57.492,
		-62.647, 55.218, -63.668, 52.753, -64.291, 50.159, -64.495, 47.775,
	],
	frameInner: [
		-57.5, -47.5, -57.377, -49.064, -57.011, -50.59, -56.41, -52.04,
		-55.59, -53.378, -54.571, -54.571, -53.378, -55.59, -52.04, -56.41,
		-50.59, -57.011, -49.064, -57.377, -47.5, -57.5, 47.5, -57.5,
		49.064, -57.377, 50.59, -57.011, 52.04, -56.41, 53.378, -55.59,
		54.571, -54.571, 55.59, -53.378, 56.41, -52.04, 57.011, -50.59,
		57.377, -49.064, 57.5, -47.5, 57.5, 47.5, 57.377, 49.064,
		57.011, 50.59, 56.41, 52.04, 55.59, 53.378, 54.571, 54.571,
		53.378, 55.59, 52.04, 56.41, 50.59, 57.011, 49.064, 57.377,
		47.5, 57.5, -47.5, 57.5, -49.064, 57.377, -50.59, 57.011,
		-52.04, 56.41, -53.378, 55.59, -54.571, 54.571, -55.59, 53.378,
		-56.41, 52.04, -57.011, 50.59, -57.377, 49.064, -57.5, 47.5,
	],
	frameBottom: 22.114,
	frameTop: 22.614,
	spin: 45,
	tilt: -65,
}
